import { assertUnreachable } from '../../shared/assertUnreachable';
import { isOrderWorkflowLineItem, LineItem } from './LineItem';
import { matchLineItemType } from './LineItemUtils';
import { isPriceCalculationInput } from './PriceCalculationInput';
export function matchUnwaivableFeeInput(input, { lineItem, priceCalculationInput, orderWorkflowLineItem, quotes }) {
    if (input instanceof LineItem) {
        return lineItem(input);
    }
    else if (isPriceCalculationInput(input)) {
        return priceCalculationInput(input);
    }
    else if (isOrderWorkflowLineItem(input)) {
        return orderWorkflowLineItem(input);
    }
    else if (Array.isArray(input)) {
        return quotes(input);
    }
    else {
        assertUnreachable(input);
    }
}
/**
 * ST-320 At the time of writing, only audio+STT orders have unwaivable fees.
 *
 * Although this is a domain concern, the function is placed in contracts
 * because we need it in workflow-service and ftr-web.
 */
export function hasUnwaivableFees(input) {
    return matchUnwaivableFeeInput(input, {
        lineItem: l => matchLineItemType(l, {
            audio: a => a.speechToTextAdded,
            transcript: () => false,
            realtime: () => false,
        }),
        priceCalculationInput: i => !!i.speechToTextAdded,
        orderWorkflowLineItem: l => !!l.speechToTextAdded,
        quotes: qs => !!qs.find(q => { var _a; return (_a = q === null || q === void 0 ? void 0 : q.sttFee) === null || _a === void 0 ? void 0 : _a.amount.isGreaterThan(0); }),
    });
}
